import { getContext, setContext } from "svelte";
export function isInsideModal(): boolean {
  return getContext<boolean>("isInsideModal");
}
export function setIsInsideModal(value: boolean) {
  setContext<boolean>("isInsideModal", value);
}
